import React from 'react';
import { Checkbox, CheckboxProps } from '@material-ui/core';

export function CustomCheckbox({ ...props }: CheckboxProps) {
	return <Checkbox color="primary" {...props} />;
}
